import _inheritsLoose from "@babel/runtime-corejs3/helpers/inheritsLoose";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";
import { __decorate } from "tslib";
import { Component, createRef } from 'intact-vue-next';
import { bind } from '../utils';
import template from './index.vdt';
import { useConfigContext } from '../config';
var typeDefs = {
  disabled: Boolean,
  value: null,
  trueValue: null
};
var defaults = function defaults() {
  return {
    value: false,
    trueValue: true
  };
};
var events = {
  click: true,
  change: true
};
export var Radio = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Radio, _Component);
  function Radio() {
    var _context;
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, _concatInstanceProperty(_context = [this]).call(_context, args)) || this;
    _this.elementRef = createRef();
    _this.config = useConfigContext();
    return _this;
  }
  var _proto = Radio.prototype;
  _proto.onKeypress = function onKeypress(e) {
    if (e.keyCode === 13) {
      this.elementRef.value.click();
    }
  };
  _proto.onClick = function onClick(e) {
    var _this$get = this.get(),
      value = _this$get.value,
      trueValue = _this$get.trueValue,
      disabled = _this$get.disabled;
    if (!disabled && value !== trueValue) {
      this.set('value', trueValue);
      this.trigger('click', e);
      this.trigger('change', trueValue, e);
    } else {
      this.trigger('click', e);
    }
  };
  _proto.fixClick = function fixClick(e) {
    // ignore the click event from label, otherwise it will trigger click event twice
    if (e.target !== this.refs.input) {
      e.stopPropagation();
    }
  };
  return Radio;
}(Component);
Radio.template = template;
Radio.typeDefs = typeDefs;
Radio.defaults = defaults;
Radio.events = events;
__decorate([bind], Radio.prototype, "onKeypress", null);
__decorate([bind], Radio.prototype, "onClick", null);
__decorate([bind], Radio.prototype, "fixClick", null);